import React, {useContext, useEffect, useState} from 'react'
import axios from 'axios'

const StripeContext = React.createContext({
    client: null,
})

export const StripeProvider = (props) => {
    const [client, setClient] = useState(null);
    useEffect(() => {
        axios
            .get('/api/stripe/public_key')
            .then(({
                       data
                   }) => {
                console.log('stripe key:', data.publishable_key)
                setClient(window.Stripe(data.publishable_key))
            })
    }, [])
    return <StripeContext.Provider value={{
        client
    }} {...props}/>
}

const useStripe = () => useContext(StripeContext);
export default useStripe
